import { ActivityTypeEnum } from './_deprecated/ActivityElement';

export type CodeEditorActivity = {
  id: number;
  activity: number;
  type: ActivityTypeEnum;
  identifier: string;
  order: number;
  title: string;
  subtitle: string;
  content: string;
  language: LanguageCodeEditorEnum;
  initialCode: string | null;
  solutionCode: string | null;
};

export enum LanguageCodeEditorEnum {
  JAVASCRIPT = 'JAVASCRIPT',
  PYTHON = 'PYTHON',
}

export type CodeEditorRuntime = {
  aliases: string[];
  language: LanguageCodeEditorEnum;
  version: string;
};

export type CodeEditorTestCase = {
  id: number;
  codeEditorActivityId: number;
  input: string;
  expectedOutput: string;
};

export type ExecuteCode = {
  language: string;
  version: string;
  files: File[];
  input?: string;
};

type File = {
  name: string;
  content: string;
  encoding: string;
};
